import script from "./ClipboardExportDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipboardExportDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStepper,QStep,QStepperNavigation,QBtn,QSpinnerDots,QSpinnerGears});
